import ScheduledEventUser from './scheduled-event-user';
import logError from '../../utilities/logging/log-error';

//

const SESSION_IMMINENT_THRESHOLD = 900000; // 15 minutes (in milliseconds)

//

function _createEventFromCourse(
  {
    entity,
    entity: {
      course: { name, conference_url: joinUrl, conference_password: joinPassword, participants },
    },
    ...eventProperties
  },
  studentId
) {
  const studentParticipant = participants.find(
    (participant) => participant.student_id === studentId
  );
  const tutorParticipant = participants.find((participant) => participant.role === 'tutor');
  return {
    ..._getCommonProperties({ ...eventProperties, entity }),
    joinUrl,
    joinPassword,
    name,
    online: true,
    // Note: Student users don't currently have `participant[role]` data, so we need to fallback
    // to just the participant
    student: ScheduledEventUser('student', studentParticipant?.student || studentParticipant),
    tutor: ScheduledEventUser('tutor', tutorParticipant?.tutor || tutorParticipant),
  };
}

function _createEventFromTutoringSession({
  entity,
  entity: {
    has_ended: hasEnded,
    is_online: online,
    online_session_urls: {
      join_online_session_as_student_url: joinUrl,
      online_session_record_url: recordUrl,
      session_snapshot_url: snapshotUrl,
    },
    source_data: { tutoring_appointment: appointment, tutoring_session: session },
    subject_name: name,
  },
  ...eventProperties
}) {
  return {
    ..._getCommonProperties({ ...eventProperties, entity }),
    hasEnded,
    joinUrl,
    name,
    online,
    recordUrl,
    snapshotUrl,
    student: ScheduledEventUser('student', (appointment || session)?.student),
    tutor: ScheduledEventUser('tutor', (appointment || session)?.tutor),
  };
}

function _getCommonProperties({ end_time: endTime, start_time: startTime, type, entity: { id } }) {
  const eventActive = () => {
    const now = Date.now();
    return now >= Date.parse(startTime) && now <= Date.parse(endTime);
  };
  const eventImminent = () => {
    const startTimeOffset = Date.parse(startTime) - Date.now();
    return startTimeOffset > 0 && startTimeOffset < SESSION_IMMINENT_THRESHOLD;
  };
  const eventOccurring = () => eventImminent(startTime) || eventActive(startTime, endTime);

  return {
    active: eventActive,
    endTime,
    imminent: eventImminent,
    occurring: eventOccurring,
    sessionId: id,
    startTime,
    type,
  };
}

// Exports
// -------

export default function ScheduledEvent(event, studentId) {
  try {
    switch (event.type) {
      case 'course-meeting':
        return _createEventFromCourse(event, studentId);

      case 'tutoring-session-event':
        return _createEventFromTutoringSession(event);

      default:
        logError(`[Unexpected Data] Unsupported event type: ${event.type}`);
    }
  } catch (error) {
    // Unprocessable entity.
    logError(error);
  }
}
